import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReservationStatusNameConstants } from '@uzurv/core';
import { RideTrackingState } from './ride-tracking.reducer';

export const rideTrackingState = createFeatureSelector<RideTrackingState>('rideTracking');

export const getLoading = createSelector(rideTrackingState, (state: RideTrackingState) => state.loading);

export const getCurrentTab = createSelector(rideTrackingState, (state: RideTrackingState) => state.currentTab);

export const getPageNumber = createSelector(rideTrackingState, (state: RideTrackingState) => state.pageNumber);

export const getPageSize = createSelector(rideTrackingState, (state: RideTrackingState) => state.pageSize);

export const getSelectedTransitPrograms = createSelector(rideTrackingState, (state: RideTrackingState) => state.selectedTransitPrograms);

export const getSelectedVehicleTypes = createSelector(rideTrackingState, (state: RideTrackingState) => state.selectedVehicleTypes);

/**
 * N.B. this is here to prevent no filtering of the active rides tab. Not having this will
 * cause ALL rides to come back from the API including very old completed rides
 */
const defaultReservationStatuses = [
  ReservationStatusNameConstants.SCHEDULED,
  ReservationStatusNameConstants.DRIVER_EN_ROUTE,
  ReservationStatusNameConstants.PICK_UP_ARRIVED,
  ReservationStatusNameConstants.IN_PROGRESS,
  ReservationStatusNameConstants.DROP_OFF_ARRIVED
];

export const getReservationStatuses = createSelector(rideTrackingState, (state: RideTrackingState) =>
  state.reservationStatuses.filter(status => defaultReservationStatuses.some(validStatus => validStatus === status.name))
);

export const getSelectedReservationStatuses = createSelector(
  rideTrackingState,
  (state: RideTrackingState) => state.selectedReservationStatuses
);

export const getSelectedReservationStatusesForAPI = createSelector(rideTrackingState, (state: RideTrackingState) =>
  state.selectedReservationStatuses.length === 0
    ? state.reservationStatuses.filter(status => defaultReservationStatuses.some(validStatus => validStatus === status.name))
    : state.selectedReservationStatuses
);

export const getRides = createSelector(rideTrackingState, (state: RideTrackingState) => state.rides);
